export const environment = {
    production: true,
    envName: 'Production',
	appInsights: {
        instrumentationKey: '944cfc21-8241-41fb-ae97-1bbc2712d43f',
    }
};
